var _linearGradient, _radialGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrawing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "71.11 0 369.779 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50.005%",
    x2: "50.005%",
    y1: "8.586%",
    y2: "100.014%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0.02
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: "3.168%",
    cy: "2.763%",
    gradientTransform: "matrix(1 0 0 .72222 0 .008)",
    r: "161.248%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.667 0h206.222l128 128v348.444c0 19.637-15.919 35.556-35.556 35.556H106.667c-19.637 0-35.556-15.919-35.556-35.556V35.556C71.111 15.919 87.03 0 106.667 0z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.111 469.333c0 19.637 15.919 35.556 35.556 35.556h298.666c19.637 0 35.556-15.919 35.556-35.556v7.111c0 19.637-15.919 35.556-35.556 35.556H106.667c-19.637 0-35.556-15.919-35.556-35.556z",
    fill: "#3e2723",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.667 0h206.222v7.111H106.667C87.03 7.111 71.11 23.03 71.11 42.667v-7.111C71.111 15.919 87.03 0 106.667 0z",
    fill: "#fff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 113.778l120.889 120.889V128",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.889 0l128 128h-92.445c-19.636 0-35.555-15.919-35.555-35.556z",
    fill: "#eda29b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.444 284.444c0-39.272-31.838-71.11-71.11-71.11s-71.112 31.838-71.112 71.11c0 39.273 31.839 71.112 71.111 71.112s71.111-31.839 71.111-71.112zm-71.11 42.667c-23.528 0-42.667-19.139-42.667-42.667 0-23.527 19.139-42.666 42.666-42.666S256 260.917 256 284.444c0 23.528-19.139 42.667-42.667 42.667zm92.444-14.222c-7.111 28.444-28.445 49.778-49.778 56.889v56.889h113.778V312.889z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.667 0h206.222l128 128v348.444c0 19.637-15.919 35.556-35.556 35.556H106.667c-19.637 0-35.556-15.919-35.556-35.556V35.556C71.111 15.919 87.03 0 106.667 0z",
    fill: "url(#b)",
    fillOpacity: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawing);
export default __webpack_public_path__ + "static/media/drawing.388aa1103a2917faaf8f8324f318ed1e.svg";
export { ForwardRef as ReactComponent };